/**
 * localStorage shim that carries a share-attribution ID through the
 * signup → checkout flow. The unauthed share-landing CTA puts the ID
 * here so SignupForm → PricingPage → checkout API can pick it back up
 * and pass it to Stripe as `subscription.metadata.share_id`, which the
 * billing webhook then resolves to the sharer's user_id via
 * `share_slips`.
 *
 * Previously this stored a long signed token (when the share URL itself
 * carried the full payload). Renamed alongside the short-ID refactor;
 * value is now the 8-12 char `share_slips.id`.
 */

const SHARE_ID_TTL_MS = 30 * 24 * 60 * 60 * 1000;

const KEY = 'share_id';

export function getStoredShareId(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const { id, ts } = JSON.parse(raw);
    if (Date.now() - ts > SHARE_ID_TTL_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return id;
  } catch {
    window.localStorage.removeItem(KEY);
    return null;
  }
}

export function storeShareId(id: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KEY, JSON.stringify({ id, ts: Date.now() }));
}

export function clearShareId(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(KEY);
}
